export default{
    cadastra:{
        method:'post',
        url:'certificado/cadastro'
    },
    delete:{
        method:'delete',
        url:'certificado/deletar{/id}'
    },
    lista:{
        method:'get',
        url:'certificado/lista'
    },
    editar:{
        method:'get',
        url:'certificado/editar{/id}'
    },
    update:{
        method:'post',
        url:'certificado/update'
    },
}